export const namedPersons = [
  {
    nameId: "Benjamin Britton",
    gNumber: "G-259",
    sex: "Male",
    age: "Adult",
    ageCat: "Old Adult",
    ageRange: "50+",
    ageAtDeath: null,
    ancestry: "Unknown",
    dateOfDeath: "1782",
    yearOfDeath: 1782,
    coffinShape: "Hex",
    preservation: "Unknown",
    lidType: "Unknown",
    coffinHandles: "Unknown",
    notes: "Confirmed named burial from NamedBurials.docx",
  },
  {
    nameId: "Thomas Weir",
    gNumber: "G-129",
    sex: "Male",
    age: "Adult",
    ageCat: "Young Adult",
    ageRange: "23-35",
    ageAtDeath: null,
    ancestry: "Unknown",
    dateOfDeath: "",
    yearOfDeath: null,
    coffinShape: "Hex",
    preservation: "Unknown",
    lidType: "Unknown",
    coffinHandles: "Unknown",
    notes: "Confirmed named burial from NamedBurials.docx",
  },
  {
    nameId: "P.R.",
    gNumber: "G-123",
    sex: "Female",
    age: "Adult",
    ageCat: "Middle Adult",
    ageRange: "",
    ageAtDeath: null,
    ancestry: "Unknown",
    dateOfDeath: "",
    yearOfDeath: null,
    coffinShape: "Hex",
    preservation: "Unknown",
    lidType: "Unknown",
    coffinHandles: "Unknown",
    notes: "Confirmed named burial from NamedBurials.docx",
  },
  {
    nameId: "R or B Watson",
    gNumber: "G-286",
    sex: "Male",
    age: "Adult",
    ageCat: "Young Adult",
    ageRange: "23-35",
    ageAtDeath: null,
    ancestry: "Unknown",
    dateOfDeath: "1775",
    yearOfDeath: 1775,
    coffinShape: "Hex",
    preservation: "Unknown",
    lidType: "Unknown",
    coffinHandles: "Unknown",
    notes: "Confirmed named burial from NamedBurials.docx",
  },
  {
    nameId: "Israel Morris",
    gNumber: "G-403",
    sex: "Male",
    age: "Adult",
    ageCat: "Young Adult",
    ageRange: "20-30",
    ageAtDeath: null,
    ancestry: "Unknown",
    dateOfDeath: "1754",
    yearOfDeath: 1754,
    coffinShape: "Hex",
    preservation: "Unknown",
    lidType: "Unknown",
    coffinHandles: "Unknown",
    notes: "Confirmed named burial from NamedBurials.docx (listed as possible G-403)",
  },
  {
    nameId: "E.S.",
    gNumber: "G-157",
    sex: "Unknown",
    age: "Adult",
    ageCat: "Middle Adult",
    ageRange: "",
    ageAtDeath: null,
    ancestry: "Unknown",
    dateOfDeath: "1750",
    yearOfDeath: 1750,
    coffinShape: "Hex",
    preservation: "Unknown",
    lidType: "Unknown",
    coffinHandles: "Unknown",
    notes: "Confirmed named burial from NamedBurials.docx",
  },
  {
    nameId: "Unknown Individual (G-131)",
    gNumber: "G-131",
    sex: "Unknown",
    age: "Unknown",
    ageCat: "Unknown",
    ageRange: "",
    ageAtDeath: null,
    ancestry: "Unknown",
    dateOfDeath: "173?",
    yearOfDeath: null,
    coffinShape: "Unknown",
    preservation: "Unknown",
    lidType: "Unknown",
    coffinHandles: "Unknown",
    notes: "Confirmed burial with unknown name from NamedBurials.docx",
  },
  {
    nameId: "Unknown Individual (G-188)",
    gNumber: "G-188",
    sex: "Male",
    age: "Adult",
    ageCat: "Middle Adult",
    ageRange: "25-44",
    ageAtDeath: null,
    ancestry: "Unknown",
    dateOfDeath: "1791",
    yearOfDeath: 1791,
    coffinShape: "Unknown",
    preservation: "Unknown",
    lidType: "Unknown",
    coffinHandles: "Unknown",
    notes: "Confirmed burial with unknown name from NamedBurials.docx",
  },
];

export const NAMED_COUNT = namedPersons.length;
